import { render, staticRenderFns } from "./allarea.vue?vue&type=template&id=50c9e973&scoped=true&"
import script from "./allarea.vue?vue&type=script&lang=js&"
export * from "./allarea.vue?vue&type=script&lang=js&"
import style0 from "./allarea.vue?vue&type=style&index=0&id=50c9e973&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c9e973",
  null
  
)

export default component.exports